import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
    showLegend: { type: Boolean, default: false },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(this.chart, this.dataValue, this.showLegendValue)
  }

  renderChart(chart, collection, showLegend) {
    const collectionMax = collection.reduce(
      (max, name) => (name.count > max.count ? name : max),
      collection[0],
    )

    chart.setOption({
      tooltip: {
        trigger: "item",
        confine: true,
        valueFormatter: (value) => `${value}%`,
      },
      legend: {
        bottom: "0%",
        left: "left",
        itemWidth: 13,
        itemHeight: 13,
        icon: "circle",
        textStyle: {
          color: "#F3F3F3B2",
          fontSize: 12,
        },
        show: showLegend,
      },
      title: {
        left: "center",
        top: "center",
        text: `${collectionMax.count}%`,
        subtext: `.${collectionMax.ioc}`,
        itemGap: -1,
        textStyle: {
          color: "#fff",
          fontSize: 20,
          lineHeight: 20,
          fontWeight: "bold",
        },
        subtextStyle: {
          color: "#B6C7D8",
          fontSize: 13,
        },
      },
      series: [
        {
          type: "pie",
          radius: ["40%", "60%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 0,
            borderColor: "#0D1926",
            borderWidth: 2,
          },
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: false,
            },
          },
          labelLine: {
            show: false,
          },
          data: collection.map(({ ioc, count }) => {
            return {
              name: `.${ioc}`,
              value: count,
            }
          }),
        },
      ],
    })
  }
}
